import { MainLayout } from "../../layout/MainLayout";
import { Grid } from "../../UI/Grid";
// import { Typography } from "../../UI/Typography";
import { PlacementWorksheetTable } from "../../components/PlacementWorksheetTable";
import { PlacementWorksheetRightPopup } from "../../components/PlacementWorksheetRightPopup";
import { PlacementWorksheetRightPopupWrapper } from "../../components/PlacementWorksheetRightPopup/PlacementWorksheetRightPopupWrapper";
import { PlacementWorksheetSettings } from "../../components/PlacementWorksheetSettings";
import { PlacementWorksheetUnitTypeSelector } from "../../components/PlacementWorksheetUnitTypeSelector";
// import { PlacementWorksheetAllowedFilterer } from "../../components/PlacementWorksheetAllowedFilterer";
import { ModalProvider } from "../../contexts/ModalContext";
import { PWSelectedResidentBottomPopup } from "../../components/PWSelectedResidentBottomPopup";
import { usePopupContext } from "../../contexts/PopupContext/context";
import { Box } from "../../UI/Box";
import { usePlacementWorksheetContext, withPlacementWorksheetProvider } from "../../contexts/PlacementWorksheetContext";
import { PlacementWorksheetDesc } from "../../components/PlacementWorksheetDesc";
import { DownloadCSVButton } from "../../components/DownloadCSVButton";
import {
  fetchPlacementReport,
} from "../../services/PlacementWorksheetApi";
import { useNetwork } from "../../hooks/useNetwork";
import useAuth from "../login/AuthContext";

const RIGHT_POPUP_WIDTH = 300;

const BottomSpacing = () => {
  const { selectedResidents } = usePopupContext();

  return <>{!!selectedResidents?.length && <Box height="15vh" />}</>;
};

export const PlacementWorksheetPage = withPlacementWorksheetProvider(() => {
  const { selectedNetwork } = useNetwork();
  const { isWriteAccess, getAuthToken } = useAuth();
  const { l2Id, l3Id, isLoading } = usePlacementWorksheetContext();

  const handleDownloadCSV = async () => {
    if (!l2Id || !l3Id || !selectedNetwork) return;
    return fetchPlacementReport(selectedNetwork.l1Id, l2Id, l3Id, await getAuthToken());
  };

  return (
    <MainLayout title="Placement Worksheet">
      {isWriteAccess() && (
        <>
          <ModalProvider>
            <PlacementWorksheetRightPopup width={RIGHT_POPUP_WIDTH} />
            <PlacementWorksheetRightPopupWrapper popupWidth={RIGHT_POPUP_WIDTH}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <ModalProvider>
                    <PlacementWorksheetDesc />
                  </ModalProvider>
                </Grid>
                <Grid item container alignItems="flex-end" sx={{ position: 'relative', zIndex: 20 }}>
                  <Grid item xs>
                    <PlacementWorksheetUnitTypeSelector />
                  </Grid>
                  <Grid item>
                    <PlacementWorksheetSettings />
                  </Grid>
                </Grid>
                <Grid item container alignItems="flex-end">
                  <DownloadCSVButton apiCall={handleDownloadCSV} isDisabled={!l2Id || !l3Id || !selectedNetwork}> Download CSV Report </DownloadCSVButton>
                </Grid>

                {l2Id && l3Id && selectedNetwork && (
                  <>
                    {/* <Grid item container xs={12} gap={1} alignItems="center" mb={2}>
                  <PlacementWorksheetAllowedFilterer />
                </Grid> */}
                    <Grid item xs={12}>
                      {isLoading && (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                          Loading placement worksheet data...
                        </div>
                      )}
                      <PlacementWorksheetTable />
                    </Grid>
                  </>
                )}
              </Grid>

            </PlacementWorksheetRightPopupWrapper>
            <PWSelectedResidentBottomPopup />
          </ModalProvider>
          <BottomSpacing />
        </>
      )}
    </MainLayout>
  );
});
